export default __webpack_public_path__ + "resources/icons/n110-ceb5.png";